import {
  AllSites, AllStatesOrTerritories
} from "../../../models";

export class Sites extends AllSites {
  constructor() {
    super();
    this.active = false;
    this.siteName = null;
    this.siteCode = null;
    this.payrollSiteId = null;
    this.payrollSiteName = null;
    this.payrollSiteCode = null;
    this.requiresStep2Approval = false;
    this.hasFastPlant = false;
    this.sanRequired = false;
    this.tenantId = 0
    this.siteId = 0
    this.companySite = true;
  }
}
export class States extends AllStatesOrTerritories{
  constructor(){
    super();
    this.stateOrTerritory = null;
    this.abbreviation = null;
    this.postalCode = null;
    this.isDefault = false;
    this.tenantId = 0;
    this.stateOrTerritoryId = 0;
  }
}
